import React from 'react'

import { PriceRiseDetails } from '~/components/deal-card/components/price-rise-details'

import BaseModal from './base-modal'
import { ModalButton } from './sections/button'
import { Header } from './sections/header'
import { InfoList } from './sections/info-list'
import { InfoTable } from './sections/info-table'
import { SmallPrint, Speed, SpeedComparison } from './speed-details'

export const DetailsModal = ({ isOpen, setOpen, modalType, content }) => {
  return (
    <>
      <BaseModal isOpen={isOpen} setOpen={setOpen}>
        <Header {...content.header} />
        {modalType === 'Price details' && (
          <>
            {content.infoTables && content.infoTables.map((infoTable, idx) => <InfoTable key={idx} {...infoTable} />)}

            <PriceRiseDetails providerId={content.providerId} />

            <ModalButton link={content.link} />

            <InfoList {...content.infoList} />
          </>
        )}
        {modalType === 'Speed details' && (
          <>
            <Speed
              title={content.downloadSpeed.title}
              body={content.downloadSpeed.body}
              subTitle={content.downloadSpeed.subTitle}
              speed={content.downloadSpeed.speed}
            />
            <Speed
              title={content.uploadSpeed.title}
              body={content.uploadSpeed.body}
              subTitle={content.uploadSpeed.subTitle}
              speed={content.uploadSpeed.speed}
            />

            {content.speedComparison && (
              <SpeedComparison
                icon={content.speedComparison.icon}
                title={content.speedComparison.title}
                body={content.speedComparison.body}
              />
            )}

            <SmallPrint smallPrint={content.smallPrint} />
          </>
        )}
      </BaseModal>
    </>
  )
}
